import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementInstanceRef } from "./AgreementInstanceRef";
import type { AgreementInstanceStaff } from "./AgreementInstanceStaff";
import type { AgreementRef } from "./AgreementRef";
import type { AgreementStaff } from "./AgreementStaff";
import type { PersonAgreementInstanceDTOBase } from "./PersonAgreementInstanceDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";

export class PersonAgreementInstanceStaff implements PersonAgreementInstanceDTOBase, ProfilePersonBase {
  constructor(public readonly assignId: number, public readonly agreementInstanceId: AgreementInstanceStaff | null, public readonly agreementId: AgreementStaff | null, public readonly prefix: string | null, public readonly first: string | null, public readonly middle: string | null, public readonly last: string | null, public readonly suffix: string | null, public readonly preferred: string | null, public readonly organization: string | null, public readonly agreedOn: Date | null, public readonly agreementExpiration: Date | null, public readonly ipAddress: string | null, public readonly userAgent: string | null, public readonly email: string | null, public readonly agreementAction: string | null, public readonly personId: PersonStaff | null, public readonly agreementInstanceIdTargetIds: AgreementInstanceRef, public readonly agreementIdTargetIds: AgreementRef | null, public readonly agreementName: string | null) {
    this.cbiServiceContext = null;
    this.agreementInstanceIdLoaded = this.agreementInstanceId != null;
    this.agreementInstanceIdCached = this.agreementInstanceId;
    this.agreementIdLoaded = this.agreementId != null;
    this.agreementIdCached = this.agreementId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private agreementInstanceIdLoaded: boolean;
  private agreementInstanceIdCached: AgreementInstanceStaff | null;
  private agreementIdLoaded: boolean;
  private agreementIdCached: AgreementStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async agreementInstanceIdLazy(): Promise<AgreementInstanceStaff> {
    if (!this.agreementInstanceIdLoaded) {
      this.agreementInstanceIdCached = await this.cbiServiceContext!.catalogService().getAgreementInstanceStaff(this.agreementInstanceIdTargetIds.assignId);
      this.agreementInstanceIdLoaded = true;
    }
    return this.agreementInstanceIdCached!;
  }
  async agreementIdLazy(): Promise<AgreementStaff | null> {
    if (!this.agreementIdLoaded) {
      this.agreementIdCached = await (this.agreementIdTargetIds != null ? this.cbiServiceContext!.catalogService().getAgreementStaff(this.agreementIdTargetIds.assignId) : Promise.resolve(null));
      this.agreementIdLoaded = true;
    }
    return this.agreementIdCached;
  }
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonAgreementInstanceStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
